/* [BD feat] Variant Switcher Modal (Standard Options + Combinational Swatch Fix) */
(function() {
  'use strict';

  let modalContainer = null;
  let variantData = null;
  let swatchConfig = {}; // Stores all swatches (Hex + Images)
  let materialImages = {}; // Stores static material images
  let currentActiveOptionIndex = 0;
  let selectedOptions = {};
  let productRoot = null;

  function init() {
    const switcher = document.querySelector('.bd-variant-switcher');
    if (!switcher) return;

    productRoot = switcher.closest('.shopify-section');
    if (!productRoot) return;

    const dataScript = switcher.querySelector('[data-variant-data]');
    const swatchScript = document.getElementById('bd-swatch-config');
    const materialScript = document.getElementById('bd-material-images');
    if (!dataScript) return;

    try { variantData = JSON.parse(dataScript.textContent); } catch (error) { return; }
    try { if (swatchScript) swatchConfig = JSON.parse(swatchScript.textContent); } catch (e) {}
    try { if (materialScript) materialImages = JSON.parse(materialScript.textContent); } catch (e) {}

    // Scope form to current product only
    const productForm = productRoot.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      const variantInput = productForm.querySelector('[name="id"]');
      if (variantInput) {
        const currentVariant = variantData.variants.find(
          v => v.id == variantInput.value
        );
        if (currentVariant) {
          variantData.options.forEach((opt, idx) => {
            selectedOptions[idx] = currentVariant.options[idx];
          });
        }
      }
    }

    subscribeToVariantChanges(productRoot);
    createModal();

    const openButton = switcher.querySelector('[data-open-variant-modal]');
    const cycleButton = switcher.querySelector('[data-cycle-variant]');

    if (openButton) openButton.addEventListener('click', openModal);
    if (cycleButton) cycleButton.addEventListener('click', cycleToNextVariant);
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modalContainer) closeModal();
    });
  }

  function subscribeToVariantChanges(productRoot) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        const newVariant = event.data?.variant;
        if (!newVariant || !newVariant.id) return;

        // Ensure variant belongs to this product
        const belongsToThisProduct = variantData.variants.some(
          v => v.id === newVariant.id
        );

        if (!belongsToThisProduct) return;

        variantData.options.forEach((opt, idx) => {
          selectedOptions[idx] = newVariant.options[idx];
        });

        updateSwitcherImage();
      });
    }
  }

  function createModal() {
    if (modalContainer) return;
    modalContainer = document.createElement('div');
    modalContainer.className = 'bd-variant-modal';
    modalContainer.setAttribute('aria-hidden', 'true');
    modalContainer.innerHTML = `
      <div class="bd-variant-modal__container"><div class="bd-variant-modal__content"></div></div>
    `;
    document.body.appendChild(modalContainer);
  }

  function openModal() {
    if (!modalContainer || !variantData) return;
    currentActiveOptionIndex = 0;
    renderModalContent();
    modalContainer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bd-variant-modal-open');
  }

  function closeModal() {
    if (!modalContainer) return;
    modalContainer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bd-variant-modal-open');
  }

  function renderModalContent() {
    const contentContainer = modalContainer.querySelector('.bd-variant-modal__content');
    const currentVariant = getCurrentVariant();
    let currentImage = currentVariant?.featured_image || variantData.productFirstImage;

    let html = `
      <div class="bd-variant-modal__overlay" data-close-modal></div>
      <div class="bd-variant-modal__image-wrapper">
        <img src="${currentImage || '//'}" alt="Product variant" class="bd-variant-modal__image" data-variant-image>
      </div>
    `;

    if (variantData.options.length >= 2) {
      html += '<div class="bd-variant-modal__switcher-wrapper"><div class="bd-variant-modal__switcher">';
      variantData.options.forEach((option, index) => {
        html += `<button class="text--xs bd-variant-modal__switcher-button ${currentActiveOptionIndex === index ? 'bd-variant-modal__switcher-button--active' : ''}" data-switch-option="${index}" type="button">${selectedOptions[index] || option.name}</button>`;
      });
      html += `</div><button class="bd-variant-modal__close" type="button" data-close-modal aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>`;
    }

    const currentOptionName = variantData.options[currentActiveOptionIndex].name;

    html += `<div class="bd-variant-modal__options" data-options-grid>
    <span class="bd-variant-modal__dynamic-title">${currentOptionName} wählen</span>
    <div class="bd-dots-bg">
    </div>
    ` + renderOptionValues(currentActiveOptionIndex) + '</div>';
    
    contentContainer.innerHTML = html;
    
    contentContainer.querySelectorAll('[data-close-modal]').forEach(btn => btn.addEventListener('click', closeModal));
    contentContainer.querySelectorAll('[data-switch-option]').forEach(btn => {
      btn.addEventListener('click', function() {
        currentActiveOptionIndex = parseInt(this.getAttribute('data-switch-option'));
        renderModalContent();
      });
    });
    contentContainer.querySelectorAll('[data-option-value]').forEach(btn => btn.addEventListener('click', handleOptionClick));
  }

  function renderOptionValues(optionIndex) {
    if (!variantData.options[optionIndex]) return '';

    const optionName = variantData.options[optionIndex].name.toLowerCase();
    const materialIndex = variantData.options.findIndex(o => o.name.toLowerCase().includes('material'));
    const colorIndex = variantData.options.findIndex(o => o.name.toLowerCase().includes('farbe') || o.name.toLowerCase().includes('color'));

    let optionValues = variantData.options[optionIndex].values;

    // Filter 'Farbe' Options: Only show colors that actually exist for the currently selected Material
    if (optionIndex === colorIndex && materialIndex !== -1) {
      const currentMaterial = selectedOptions[materialIndex];
      if (currentMaterial) {
        optionValues = optionValues.filter(colorValue => {
          return variantData.variants.some(v => v.options[materialIndex] === currentMaterial && v.options[colorIndex] === colorValue);
        });
      }
    }

    let html = '';

    optionValues.forEach(value => {
      const isSelected = selectedOptions[optionIndex] === value;
      const isAvailable = variantData.variants.some(v => v.options[optionIndex] === value && v.available);
      
      let buttonInner = `<span class="bd-variant-modal__option-text text--xxs">${value}</span>`;
      let hasMedia = false;

      const valueDowncase = value.toLowerCase().trim();
      let swatch = null;

      // Combinational Swatch / Static Material Image Checks
      if (optionIndex === materialIndex) {
          // Static material image from collection
          if (materialImages[valueDowncase]) {
              swatch = { type: 'image', value: materialImages[valueDowncase] };
          } else {
              // Fallback combinational swatch check if not found in collection
              const currentColor = selectedOptions[colorIndex] ? selectedOptions[colorIndex].toLowerCase().trim() : '';
              const combinedKey = currentColor ? `${valueDowncase}-${currentColor}` : '';
              swatch = swatchConfig[combinedKey] || swatchConfig[valueDowncase];
          }
      } else if (optionIndex === colorIndex) {
          const currentMaterial = selectedOptions[materialIndex] ? selectedOptions[materialIndex].toLowerCase().trim() : '';
          const combinedKey = currentMaterial ? `${currentMaterial}-${valueDowncase}` : '';
          swatch = swatchConfig[combinedKey] || swatchConfig[valueDowncase];
      } else {
          swatch = swatchConfig[valueDowncase];
      }

      if (swatch) {
         hasMedia = true;
         if (swatch.type === 'color') {
            buttonInner = `<span class="bd-variant-modal__option-color" style="background-color: ${swatch.value}; width: 100%; height: 100%; display: block; border-radius: 50%;"></span>`;
         } else {
            buttonInner = `<img src="${swatch.value}" alt="${value}" class="bd-variant-modal__option-image">`;
         }
      } else {
         const sampleVariant = findBestVariantForOption(optionIndex, value);
         const optionImage = sampleVariant?.featured_image || null;
         if (optionImage) {
            hasMedia = true;
            buttonInner = `<img src="${optionImage}" alt="${value}" class="bd-variant-modal__option-image">`;
         }
      }

      html += `
        <button class="bd-variant-modal__option ${isSelected ? 'bd-variant-modal__option--selected' : ''} ${!isAvailable ? 'bd-variant-modal__option--unavailable' : ''} ${!hasMedia ? 'bd-variant-modal__option--text' : ''}" data-option-value="${value}" data-option-index="${optionIndex}" type="button" ${!isAvailable ? 'disabled aria-disabled="true"' : ''}>
          ${buttonInner}
          <div class="bd-variant-modal__option-check"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M6 12.0005L10.2426 16.2431L18.727 7.75781" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
        </button>
      `;
    });

    return html;
  }

  function findBestVariantForOption(optionIndex, optionValue) {
    let variant = variantData.variants.find(v => {
      let allMatch = v.options[optionIndex] === optionValue && v.featured_image;
      for (let i = 0; i < variantData.options.length; i++) {
        if (i !== optionIndex && selectedOptions[i] && v.options[i] !== selectedOptions[i]) allMatch = false;
      }
      return allMatch;
    });
    if (!variant) variant = variantData.variants.find(v => v.options[optionIndex] === optionValue && v.featured_image);
    if (!variant) variant = variantData.variants.find(v => v.options[optionIndex] === optionValue);
    return variant;
  }

  function handleOptionClick(e) {
    const optionValue = this.getAttribute('data-option-value');
    const optionIndex = parseInt(this.getAttribute('data-option-index'));
    if (this.getAttribute('aria-disabled') === 'true') return;

    selectedOptions[optionIndex] = optionValue;
    let newVariant = getCurrentVariant();
    
    // Fallback: ONLY force change options if combo does not exist
    if (!newVariant) {
      newVariant = variantData.variants.find(v => v.options[optionIndex] === optionValue && v.available) 
                || variantData.variants.find(v => v.options[optionIndex] === optionValue);
      if (newVariant) variantData.options.forEach((opt, idx) => selectedOptions[idx] = newVariant.options[idx]);
    }

    if (newVariant) {
      selectVariant(newVariant.id);
      updateModalImage(newVariant.featured_image || variantData.productFirstImage);
    }
    renderModalContent();
  }

  function getCurrentVariant() {
    return variantData.variants.find(v => {
      for (let i = 0; i < variantData.options.length; i++) {
        if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });
  }

  function selectVariant(variantId) {
    const selectedVariant = variantData.variants.find(v => v.id === variantId);
    if (!selectedVariant) return;

    const variantSelectsElement = productRoot.querySelector('variant-selects');
    if (variantSelectsElement) {
      selectedVariant.options.forEach((optionValue, index) => {
        if (!optionValue) return;
        const radioInputs = variantSelectsElement.querySelectorAll(`input[type="radio"][name*="-${index + 1}"]`);
        radioInputs.forEach(radio => {
          if (radio.value === optionValue && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            if (typeof variantSelectsElement.updateSelectionMetadata === 'function') variantSelectsElement.updateSelectionMetadata({ target: radio });
          }
        });
      });
    }

    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.variantChange, { data: { variant: selectedVariant } });
    }
    updateSwitcherImage();
  }

  function updateModalImage(imageUrl) {
    const modalImage = modalContainer.querySelector('[data-variant-image]');
    if (modalImage && imageUrl) {
      modalImage.classList.add('bd-variant-modal__image--loading');
      modalImage.src = imageUrl;
      modalImage.onload = () => modalImage.classList.remove('bd-variant-modal__image--loading');
    }
  }

  function updateSwitcherImage() {
    const imageElement = document.querySelector('[data-switcher-image]');
    const colorElement = document.querySelector('[data-switcher-color]');
    const currentVariant = getCurrentVariant();
    if (!currentVariant) return;

    const materialIndex = variantData.options.findIndex(o => o.name.toLowerCase().includes('material'));
    const colorIndex = variantData.options.findIndex(o => o.name.toLowerCase().includes('farbe') || o.name.toLowerCase().includes('color'));
    
    let swatch = null;
    
    const currentMaterial = materialIndex !== -1 ? currentVariant.options[materialIndex].toLowerCase().trim() : '';
    const currentColor = colorIndex !== -1 ? currentVariant.options[colorIndex].toLowerCase().trim() : '';

    if (currentMaterial && currentColor) swatch = swatchConfig[`${currentMaterial}-${currentColor}`];
    if (!swatch && currentColor) swatch = swatchConfig[currentColor];
    if (!swatch && currentMaterial) swatch = swatchConfig[currentMaterial];

    if (swatch) {
       if (swatch.type === 'color') {
          if(colorElement) { colorElement.style.backgroundColor = swatch.value; colorElement.style.display = 'block'; }
          if(imageElement) { imageElement.style.display = 'none'; }
       } else {
          if(imageElement) { imageElement.src = swatch.value.replace(/width=\d+/, 'width=96'); imageElement.style.display = 'block'; }
          if(colorElement) { colorElement.style.display = 'none'; }
       }
    } else {
       const fallbackImage = currentVariant.featured_image || variantData.productFirstImage;
       if (fallbackImage && imageElement) {
          imageElement.src = fallbackImage.replace(/width=\d+/, 'width=96');
          imageElement.style.display = 'block';
          if(colorElement) colorElement.style.display = 'none';
       }
    }
  }

  function cycleToNextVariant() {
    const currentVariant = getCurrentVariant();
    if (!currentVariant) return;
    
    const currentIndex = variantData.variants.findIndex(v => v.id === currentVariant.id);
    let nextIndex = (currentIndex + 1) % variantData.variants.length;
    let attempts = 0;
    
    while (!variantData.variants[nextIndex].available && attempts < variantData.variants.length) {
      nextIndex = (nextIndex + 1) % variantData.variants.length;
      attempts++;
    }
    
    const nextVariant = variantData.variants[nextIndex];
    if (nextVariant && nextVariant.available) {
      variantData.options.forEach((option) => {
        const optionPosition = option.position - 1;
        const nextVariantValue = nextVariant.options[optionPosition];
        if (nextVariantValue) selectedOptions[optionPosition] = nextVariantValue;
      });
      selectVariant(nextVariant.id);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();